import { render, staticRenderFns } from "./IPSet.vue?vue&type=template&id=b4cc1ce0&"
import script from "./IPSet.vue?vue&type=script&lang=js&"
export * from "./IPSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports